import React, { useState, useEffect } from 'react';
import axios from 'axios';
import data_fetcher from './helpers/data_fetcher';

const NationalitySelect = (props) => {
  const [nationalities, setNationalities] = useState([]);
  const [choice, setChoice] = useState(props.selected || '');
  const [localisations, setLocalisations] = useState();

  useEffect(() => {
    data_fetcher.getPage().then((data) => setLocalisations(data.localisations));
  }, []);

  useEffect(() => {
    axios
      .get('/api/1.0/nationalities')
      .then((response) => {
        setNationalities(response.data.data);
      })
      .catch(() => {
        console.log('Error accessing nationalities');
      });
  }, []);

  return (
    <select
      name="nationality"
      value={choice}
      onChange={(e) => setChoice(e.target.value)}
    >
      <option value="">
        {localisations?.not_disclosed || 'Not disclosed'}
      </option>
      {nationalities.map((item) => (
        <option value={item.id} key={item.id}>
          {item.name}
        </option>
      ))}
    </select>
  );
};

export default NationalitySelect;
